import React from 'react';
import { capitalizeWords, formatLeaveDateRange } from '../../../utils/helper';
import { ILeave } from '../../../services/leave';
import { CancelOutlined, CheckCircleOutline } from '@mui/icons-material';
import { ListTable } from '../../molecules/ListTable';
export const LeaveList = ({
  Leaves,
  onManageClick,
  isLoading,
  onlyview,
  headerCells,
}: {
  Leaves: ILeave[];
  onManageClick: (id: string, action: string) => void;
  isLoading: boolean;
  onlyview?: boolean;
  headerCells: [string, number][];
}) => {
  const isPending = (leave: ILeave) =>
    String(leave.status ?? '').toUpperCase() === 'PENDING';

  const actions = onlyview
    ? undefined
    : [
        {
          icon: <CancelOutlined sx={{ fontSize: 20, color: '#F44336' }} />,
          onClick: (leave: ILeave) => onManageClick(leave._id ?? '', 'REJECTED'),
          condition: isPending,
        },
        {
          icon: (
            <CheckCircleOutline sx={{ fontSize: 20, color: '#4CAF50' }} />
          ),
          onClick: (leave: ILeave) => onManageClick(leave._id ?? '', 'APPROVED'),
          condition: isPending,
        },
      ];

  return (
    <ListTable
      headerCells={headerCells}
      rows={Leaves}
      isLoading={isLoading}
      actions={actions}
      renderCell={(leave: ILeave, colIndex: number) => {
        switch (colIndex) {
          case 0:
            return capitalizeWords(leave.technician.name) || 'N/A';
          case 1:
            return capitalizeWords(leave.leaveType.replace('_', ' '));
          case 2:
            return formatLeaveDateRange(leave.startDate, leave.endDate);
          case 3:
            return capitalizeWords(leave.reason) || 'N/A';
          case 4:
            return capitalizeWords(leave.status);

          default:
            return null;
        }
      }}
    />
    // <TableContainer sx={{ scrollbarWidth: 'none', marginTop: 0 }}>
    //   <Table>
    //     <TableBody sx={{ rowGap: 10 }}>
    //       {isLoading && <SkeletonRows />}
    //       {!isLoading &&
    //         Leaves.map((leave) => {
    //           return (
    //             <TableRow
    //               key={leave._id}
    //               sx={{
    //                 backgroundColor: '#1C1C1C',
    //                 marginBottom: 5,
    //                 borderSpacing: '0px 10px',
    //                 borderCollapse: 'separate',
    //               }}
    //             >
    //               <TableCell
    //                 sx={{
    //                   ...lockWidth(50),
    //                   textAlign: 'center',
    //                   color: '#8A8D91',
    //                 }}
    //               >
    //                 {capitalizeWords(leave.technician.name) || 'N/A'}
    //               </TableCell>
    //               <TableCell
    //                 sx={{
    //                   ...lockWidth(50),
    //                   textAlign: 'center',
    //                   color: '#8A8D91',
    //                 }}
    //               >
    //                 {leave.leaveType.replace('_', ' ')}
    //               </TableCell>
    //               <TableCell
    //                 sx={{
    //                   ...lockWidth(50),
    //                   textAlign: 'center',
    //                   color: '#8A8D91',
    //                 }}
    //               >
    //                 {formatLeaveDateRange(leave.startDate, leave.endDate)}
    //               </TableCell>
    //               <TableCell
    //                 sx={{
    //                   ...lockWidth(80),
    //                   textAlign: 'center',
    //                   color: '#8A8D91',
    //                 }}
    //               >
    //                 {capitalizeWords(leave.reason) || 'N/A'}
    //               </TableCell>
    //               <TableCell
    //                 sx={{
    //                   ...lockWidth(35),
    //                   textAlign: 'center',
    //                   color: '#8A8D91',
    //                 }}
    //               >
    //                 {leave.status}
    //               </TableCell>
    //               <TableCell
    //                 sx={{
    //                   ...lockWidth(20),

    //                   textAlign: 'center',
    //                 }}
    //               >
    //                 <Box
    //                   sx={{
    //                     display: 'flex',
    //                     justifyContent: 'center',
    //                     alignItems: 'center',
    //                     gap: 1,
    //                   }}
    //                 >
    //                   {leave.status === 'PENDING' ? (
    //                     <>
    //                       <IconButton
    //                         sx={{ color: '#F44336' }}
    //                         onClick={() => onManageClick(leave._id, 'REJECTED')}
    //                       >
    //                         <CancelOutlined sx={{ fontSize: 20 }} />
    //                       </IconButton>

    //                       <IconButton
    //                         sx={{ color: '#4CAF50' }}
    //                         onClick={() => onManageClick(leave._id, 'APPROVED')}
    //                       >
    //                         <CheckCircleOutline sx={{ fontSize: 20 }} />
    //                       </IconButton>
    //                     </>
    //                   ) : (
    //                     <Typography variant="body2" color="#888">
    //                       -
    //                     </Typography>
    //                   )}
    //                 </Box>
    //               </TableCell>
    //             </TableRow>
    //           );
    //         })}
    //     </TableBody>
    //   </Table>
    // </TableContainer>
  );
};
